import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from '../../button/button.module';
import { CircleCheckmarkModule } from '../../circle-checkmark/circle-checkmark.module';
import { ComponentLoaderModule } from '../../component-loader/component-loader.module';
import { ConsentModule } from '../../consent/consent.module';
import { FormElementsModule } from '../../form-elements/form-elements.module';
import { FormModule } from '../../form/form.module';
import { RichTextModule } from '../../rich-text/rich-text.module';
import { StepperModule } from '../../stepper/stepper.module';
import { UserInfoInputsModule } from '../../user-info-inputs/user-info-inputs.module';
import { UtilsModule } from '../../utils/utils.module';
import { BookWorkshopExternalComponent } from './book-workshop-external.component';
import { BookWorkshopStepperComponent } from './book-workshop-stepper.component';
import { BookWorkshopCarInfoComponent } from './steps/book-workshop-car-info.component';
import { BookWorkshopSelectDateComponent } from './steps/book-workshop-select-date.component';
import { BookWorkshopSelectDeliveryComponent } from './steps/book-workshop-select-delivery.component';
import { BookWorkshopSelectServiceComponent } from './steps/book-workshop-select-service.component';
import { BookWorkshopSelectShopComponent } from './steps/book-workshop-select-shop.component';
import { BookWorkshopSuccessComponent } from './steps/book-workshop-success.component';
import { BookWorkshopSummaryComponent } from './steps/book-workshop-summary.component';
import { BookWorkshopUserInfoComponent } from './steps/book-workshop-user-info.component';
import { BookWorkshopTermsNConditionsModule } from './terms-and-conditions/book-workshop-terms-n-conditions.module';

@NgModule({
    declarations: [
        BookWorkshopStepperComponent,
        BookWorkshopCarInfoComponent,
        BookWorkshopUserInfoComponent,
        BookWorkshopSelectShopComponent,
        BookWorkshopSelectServiceComponent,
        BookWorkshopSelectDeliveryComponent,
        BookWorkshopSelectDateComponent,
        BookWorkshopSummaryComponent,
        BookWorkshopSuccessComponent,
        BookWorkshopExternalComponent,
    ],
    imports: [
        CommonModule,
        TranslateModule.forChild(),
        StepperModule,
        FormsModule,
        FormModule,
        NgbDatepickerModule,
        ReactiveFormsModule,
        FormElementsModule,
        RichTextModule,
        UserInfoInputsModule,
        ButtonModule,
        CircleCheckmarkModule,
        UtilsModule,
        ConsentModule,
        BookWorkshopTermsNConditionsModule,
        ComponentLoaderModule,
    ],
})
export class BookWorkshopModule {}
